import { useId } from 'react';

/**
 * PenAnimatedIcon — Ícone de editar (caneta + quadrado) animado padrão do Joshua.
 *
 * Uso: envolva com um elemento que tenha a classe `gf-pen-animated`
 * para ativar a animação no hover (caneta escreve, papel treme).
 *
 * Exemplo:
 *   <button className="btn-edit-icon gf-pen-animated" onClick={onEdit} title="Editar">
 *     <PenAnimatedIcon size={14} />
 *   </button>
 */
export default function PenAnimatedIcon({ size = 16 }) {
  const id = useId();
  const gid = `penG${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="3" y1="0" x2="21" y2="0">
          <stop offset="0%" stopColor="#60a5fa" />
          <stop offset="100%" stopColor="#154680" />
        </linearGradient>
      </defs>
      <g className="pen-square" stroke={`url(#${gid})`}>
        <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
      </g>
      <g className="pen-tip" stroke={`url(#${gid})`}>
        <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"/>
      </g>
    </svg>
  );
}
